import BackButton from "../../../../components/Buttons/BackButton";
import BasicButton from "../../../../components/Buttons/BasicButton";
import FormBox from "../../../../components/boxes/FormBox";
import XsCont from "../../../../components/containers/Xs";
import BasicForm from "../../../../components/textField/BasicForm";
import { API_URL } from "../../../../consts/ApiUrl";
import { validationMessage } from "../../../../consts/ValidationMessage";
import {
  isValidMobilePhoneNumberPrefix,
  isValidPhoneNumberWithHyphen,
} from "../../../../utils/validationUtils";
import { Typography, Box } from "@mui/material";
import React, { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import parsePhoneNumber from 'libphonenumber-js';

type InputPhoneNumStepProps = {
  onNext: () => void;
};

const InputPhoneNumStep: FC<InputPhoneNumStepProps> = ({
  onNext,
}: InputPhoneNumStepProps) => {
  const [form, setForm] = useState({
    phoneNum: "",
  });

  const [errors, setErrors] = useState({
    phoneNum: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const newValue =
        (name === 'phoneNum' && !value.includes("-"))
      ? (parsePhoneNumber(value, "JP")?.formatNational() || value)
      : value;
    setForm((prev) => ({ ...prev, [name]: newValue }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    let valid = true;
    const newErrors = {
      phoneNum: "",
    };
    const phoneNum: string = form.phoneNum;
    if (!isValidPhoneNumberWithHyphen(phoneNum)) {
      newErrors.phoneNum = validationMessage.MOBILE_PHONE_FORMAT;
      valid = false;
    }
    if (!isValidMobilePhoneNumberPrefix(phoneNum)) {
      newErrors.phoneNum = validationMessage.MOBILE_PHONE;
      valid = false;
    }
    if (!phoneNum) {
      newErrors.phoneNum = `担当者携帯番号${validationMessage.REQUIRED}`;
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    try {
      const response = await fetch(API_URL.VERIFY, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ mode: "send", phone_number: form.phoneNum }),
      });
      if (!response.ok) {
        navigate("/error");
        return;
      }
      const data = await response.json();
      const requestId: string = data.request_id;
      const numberChangeInfo = { requestId, chargePhoneNumber: form.phoneNum };
      if (requestId) {
        sessionStorage.setItem(
          "numberChangeInfo",
          JSON.stringify(numberChangeInfo)
        );
        onNext();
      } else {
        throw new Error();
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      navigate("/error");
    }
  };
  const navigate = useNavigate();
  const handleBack = () => {
    navigate("/update");
  };

  return (
    <XsCont>
      <Box mt={10} textAlign="center">
        <Typography variant="h5" gutterBottom>
          担当者携帯番号
        </Typography>
      </Box>
      <FormBox mt={10}>
        <BasicForm
          label={"担当者携帯番号"}
          name={"phoneNum"}
          value={form.phoneNum}
          onChange={handleChange}
          error={!!errors.phoneNum}
          helperText={errors.phoneNum}
        />
      </FormBox>
      <Box mt={10} display="flex" flexDirection="column">
        <BasicButton onClick={handleSubmit} mt={2}>
          認証コード送信
        </BasicButton>
        <BackButton mt={2} onClick={handleBack}>
          キャンセル
        </BackButton>
      </Box>
    </XsCont>
  );
};

export default InputPhoneNumStep;
